module.exports = __webpack_public_path__ + "media/34.c27a0bcb.mp3";